import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ICON } from '@core/util/icon';
import { MatterFileType } from '@models/matter';
import {
	MatterFormData,
	PDFForm,
	PDFFormType,
	PDFForms,
} from '@models/matter-form-data';
import { MatterMortgage } from '@models/mortgage';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterMortgageLenderFormsRepoService } from '@repos/matter-mortgage-lender-forms/matter-mortgage-lender-forms.service';
import { SelectedMatterFormsDispatch } from '@state/global/forms/selected-matter-forms.dispatch';
import { MatterFormDataDispatch } from '@state/matter/form-data';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { filter, map, startWith } from 'rxjs/operators';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { BaseFormMapper } from '../mappers/base-form-mapper';

const base = '/assets/pdf';

@UntilDestroy()
@Component({
	selector: 'app-form-viewer',
	templateUrl: 'form-viewer.component.html',
	styleUrls: ['./form-viewer.component.scss'],
	standalone: false,
})
export class FormViewerComponent implements OnInit {
	public ICON = ICON;
	public url: string;
	public fileName: string;
	public form: PDFForm;
	public formTypes = PDFFormType;
	public baseRoute;
	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	public formMap: BaseFormMapper<any>;
	public selectedForm: MatterFormData;
	public mergedFormData;

	public PDFForms = PDFForms;
	public matterFileTypes = MatterFileType;
	public formDataId: string;
	public showViewer = true;
	public mortgage: MatterMortgage;
	public showPlaceholder = false;

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@SelectSnapshot(MatterMortgagesState.getAllMortgages)
	mortgages: MatterMortgage[];

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private matterMortgageLenderFormRepoService: MatterMortgageLenderFormsRepoService,
		private selectedMatterFormDispatch: SelectedMatterFormsDispatch,
	) {
		this.baseRoute = UrlService.Matter_Documents_Forms(this.matterId);
	}

	ngOnInit(): void {
		this.router.events
			.pipe(
				untilDestroyed(this),
				filter((e) => e instanceof NavigationEnd),
				startWith(this.router),
				map(() => this.router.url),
				map(() => this.activatedRoute),
			)
			.subscribe(async (res) => {
				if (res?.snapshot?.params?.formName) {
					const params = res?.snapshot?.params;
					this.showPlaceholder = false;

					// Fallback: check if the formName is used as the id
					if (PDFForms[params?.formName] && !params?.mortgageId) {
						this.formDataId = params?.formName;
						this.selectedForm = PDFForms[params?.formName];
						this.selectedMatterFormDispatch.SelectForm(
							this.formDataId as PDFFormType,
						);

						// this.getUrl(this.formDataId);
					} else {
						this.mortgage = this.mortgages.find(
							(mortgage) => mortgage?.id === params?.mortgageId,
						);
						// Get mortgage lender form
						const lenderForm = await this.matterMortgageLenderFormRepoService
							.Get(params?.formName, { mortgageId: params?.mortgageId })
							.toPromise();
						// formData id is the same as the lenderForm id
						this.formDataId = lenderForm.id;

						this.selectedMatterFormDispatch.SelectForm(
							lenderForm.data().documentName,
							lenderForm.id,
							this.mortgage.id,
						);
					}
				} else {
					// no form selected
					this.showPlaceholder = true;
				}
			});
	}
}
